import { render, staticRenderFns } from "./UserInfoForm.vue?vue&type=template&id=d39257de&scoped=true&"
import script from "./UserInfoForm.vue?vue&type=script&lang=js&"
export * from "./UserInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39257de",
  null
  
)

export default component.exports